import PlayerBalanceChartModal from '@/components/dialogs/player-balance-chart'
import {create} from 'vue-modal-dialogs'

export default create(PlayerBalanceChartModal, 'player')
